import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-impersonation-chip',
    standalone: true,
    imports: [CommonModule, MatIconModule, TranslocoPipe],
    templateUrl: './impersonation-chip.component.html',
    styleUrl: './impersonation-chip.component.scss',
})
export class ImpersonationChipComponent implements OnInit {
    isImpersonating = false;
    subject: string | null = null;
    stopping = false;

    constructor(
        private authService: AuthService,
        private toastrService: ToastrService,
        private transloco: TranslocoService,
    ) {}

    ngOnInit(): void {
        const info = this.authService.getImpersonationInfo();
        this.isImpersonating = info.isImpersonating;
        this.subject = info.subject;
    }

    async stopImpersonation(): Promise<void> {
        if (this.stopping) {
            return;
        }
        this.stopping = true;
        const ok = await this.authService.stopImpersonation();
        if (!ok) {
            this.stopping = false;
            this.toastrService.error(this.transloco.translate('menu.header.impersonationStopFailed'));
        }
    }
}
